import { render, staticRenderFns } from "./StoreArchives.vue?vue&type=template&id=2b0593ce&scoped=true&"
import script from "./StoreArchives.vue?vue&type=script&lang=ts&"
export * from "./StoreArchives.vue?vue&type=script&lang=ts&"
import style0 from "./StoreArchives.vue?vue&type=style&index=0&id=2b0593ce&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b0593ce",
  null
  
)

export default component.exports